import * as React                from 'react'
import { Resource as TResource } from '../../api'

import Grid from '@material-ui/core/Grid'

import loadable     from '../hocs/loadable'
import { Resource } from '../molecules'

interface ResourceListProps {
  resources: TResource []
}

const ResourceList = ({ resources }: ResourceListProps) => (
  <Grid container spacing={16}>
    {resources.map(resource => (
      <Grid item xs={6} md={4} lg={3} key={resource.url}>
        <Resource {...resource} />
      </Grid>
    ))}
  </Grid>
)

export default loadable(ResourceList)



// WEBPACK FOOTER //
// ./src/components/molecules/ResourceList.tsx